import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/home";
import ContactPage from "./pages/contact";
import ScrollToTop from "./components/ScrollTopTop";
import BlogsPage from "./pages/blog";
import BlogDetail from "./components/blog/blogDetail";
import AboutPage from "./pages/about";
import HelpPage from "./pages/Help";
import PrivacyPolicy from "./pages/privacyPolicy";
import TermsOfService from "./pages/termAndServices";
import { useEffect } from "react";

// Push page_view events to dataLayer for GTM to handle (SPA route changes)
function GTMPageView() {
  const location = useLocation();

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "page_view",
        page_path: location.pathname + location.search,
        page_title: document.title,
      });
    }
  }, [location]);

  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <GTMPageView />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/contact-us" element={<ContactPage />} />
        <Route path="/about-us" element={<AboutPage/>}/>
        <Route path="/help" element={<HelpPage/>}/>
        <Route path="/blogs" element={<BlogsPage />} />
        <Route path="/blogs/:slug" element={<BlogDetail />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;



